import styles from './deliveryInfo.module.css';
import formatDeliveryDate from '../../utils/formatDeliveryDate';
import {TrackTrace} from '../../models/trackTrace';
import {useI18nContext} from '../../i18n/i18n-react';
import {Icons, IconSizes} from '@toppy-webshop/toppy-design-system';
import {TranslationFunctions} from '../../i18n/i18n-types';
import {Icon} from '@toppy-webshop/toppy-design-system';
import clsx from 'clsx';

interface TrackTraceStateProps {
    trackTrace: TrackTrace;
    deliveryDate: Date | string | null;
}

const processState = (
    trackTrace: TrackTrace,
    deliveryDate: Date | null,
    LL: TranslationFunctions
): [Icons, string] => {
    switch (true) {
        case trackTrace.isDelivered:
            return [Icons.CHECK, LL.shipment.track.state.delivered.title()];
        case trackTrace.isFaulty:
            return [Icons.CROSS, LL.shipment.track.state.faulty.title()];
    }

    return [Icons.CAR_SPEED, LL.shipment.track.state.inTransit.title()];
};

const TrackTraceState = ({deliveryDate, trackTrace}: TrackTraceStateProps) => {
    const {LL} = useI18nContext();
    const today = new Date(new Date().setUTCHours(0, 0, 0));
    const deliveryDateObject = new Date(
        new Date(deliveryDate ? deliveryDate : '').setUTCHours(0, 0, 0)
    );
    const [icon, title] = processState(trackTrace, deliveryDateObject, LL);

    return (
        <>
            <div
                className={clsx(
                    trackTrace.isDelivered && styles['text-success'],
                    trackTrace.isFaulty && styles['text-danger']
                )}
            >
                <Icon icon={icon} size={IconSizes.XS} />
                <strong>{title}</strong>
            </div>
            {!trackTrace.isDelivered &&
                !trackTrace.isFaulty &&
                deliveryDate &&
                deliveryDateObject >= today && (
                    <div>
                        {LL.shipment.track.expectedDeliveryDate()}
                        {': '}
                        <a
                            className={styles.link__active}
                            href={trackTrace.trackTraceUrl ?? ''}
                            rel="noreferrer"
                            target="_blank"
                        >
                            {formatDeliveryDate(deliveryDateObject)}
                        </a>
                    </div>
                )}
            {!trackTrace.isDelivered &&
                (!deliveryDate || deliveryDate < today) && (
                    <div>
                        <a
                            className={styles.link__active}
                            href={trackTrace.trackTraceUrl ?? ''}
                            rel="noreferrer"
                            target="_blank"
                        >
                            {LL.shipment.track.title()}
                        </a>
                    </div>
                )}
        </>
    );
};

export default TrackTraceState;
